var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7754 8.16418C23.0683 7.87137 23.5431 7.87134 23.8359 8.16418C24.1288 8.45706 24.1288 8.93183 23.8359 9.22473L17.0605 16.0001L23.8359 22.7755C24.1287 23.0684 24.1286 23.5432 23.8359 23.8361C23.5431 24.1289 23.0683 24.1289 22.7754 23.8361L16 17.0607L9.22461 23.8361C8.93172 24.129 8.45696 24.129 8.16406 23.8361C7.8712 23.5432 7.87118 23.0684 8.16406 22.7755L14.9395 16.0001L8.16406 9.22473C7.87117 8.93184 7.87117 8.45708 8.16406 8.16418C8.45697 7.87146 8.93177 7.87135 9.22461 8.16418L16 14.9396L22.7754 8.16418Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossColor);
export default __webpack_public_path__ + "static/media/cross-color.8e742d7c1d6d5b485a897bfc54889435.svg";
export { ForwardRef as ReactComponent };